import styles from './About.module.css';

const About = () => {
    return (
        <section id="about" className="section">
            <div className="container">
                <h2 className="section-title">À propos</h2>

                <div className={styles.aboutContent}>
                    <div className={styles.aboutText}>
                        <h3 className={styles.aboutSubtitle}>
                            Passionné par le web et le digital
                        </h3>

                        <p>
                            Je suis un développeur web passionné, spécialisé dans la création de sites <strong>performants</strong>, <strong>responsifs</strong> et <strong>éco-responsables</strong>. Mon objectif est de vous aider à développer une présence en ligne forte et efficace.
                        </p>

                        <p>
                            Avec une expertise en développement web moderne, SEO, et marketing digital, je vous accompagne de A à Z dans vos projets : de la <strong>conception initiale</strong> à la <strong>maintenance</strong>, en passant par l'<strong>optimisation</strong> et la <strong>promotion</strong> de votre site.
                        </p>

                        <div className={styles.values}>
                            <div className={styles.valueCard}>
                                <svg className={styles.valueIcon} width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <path d="M24 8L28 16L36 17L30 23L32 31L24 27L16 31L18 23L12 17L20 16Z" fill="url(#valueGrad1)" />
                                    <defs>
                                        <linearGradient id="valueGrad1" x1="12" y1="8" x2="36" y2="31">
                                            <stop stopColor="#00ff9d" />
                                            <stop offset="1" stopColor="#2e8b57" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <h4>Performance</h4>
                                <p>Sites rapides et optimisés pour une expérience utilisateur exceptionnelle</p>
                            </div>

                            <div className={styles.valueCard}>
                                <svg className={styles.valueIcon} width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <circle cx="24" cy="24" r="16" stroke="url(#valueGrad2)" strokeWidth="2" fill="none" />
                                    <circle cx="24" cy="24" r="4" fill="#00ff9d" />
                                    <path d="M24 8L24 16M24 32L24 40M8 24L16 24M32 24L40 24" stroke="url(#valueGrad2)" strokeWidth="2" />
                                    <defs>
                                        <linearGradient id="valueGrad2" x1="8" y1="8" x2="40" y2="40">
                                            <stop stopColor="#00ff9d" />
                                            <stop offset="1" stopColor="#2e8b57" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <h4>Qualité</h4>
                                <p>Code propre, maintenable et respectant les standards du web</p>
                            </div>

                            <div className={styles.valueCard}>
                                <svg className={styles.valueIcon} width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <path d="M24 6C24 6 12 16 12 30C12 38 18 42 24 42C30 42 36 38 36 30C36 16 24 6 24 6Z" stroke="url(#valueGrad3)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M24 6V42" stroke="url(#valueGrad3)" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M24 30L32 22" stroke="url(#valueGrad3)" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M24 22L16 14" stroke="url(#valueGrad3)" strokeWidth="2" strokeLinecap="round" />
                                    <defs>
                                        <linearGradient id="valueGrad3" x1="12" y1="6" x2="36" y2="42" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#00ff9d" />
                                            <stop offset="1" stopColor="#2e8b57" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <h4>Éco-Conception Web</h4>
                                <p>Hébergement écologique et pratiques de développement durable</p>
                            </div>

                            <div className={styles.valueCard}>
                                <svg className={styles.valueIcon} width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <path d="M12 18C12 18 16 14 24 14C32 14 36 18 36 18" stroke="url(#valueGrad4)" strokeWidth="2" strokeLinecap="round" fill="none" />
                                    <path d="M16 24C16 24 18 22 24 22C30 22 32 24 32 24" stroke="url(#valueGrad4)" strokeWidth="2" strokeLinecap="round" fill="none" />
                                    <path d="M20 30C20 30 21 29 24 29C27 29 28 30 28 30" stroke="url(#valueGrad4)" strokeWidth="2" strokeLinecap="round" fill="none" />
                                    <circle cx="24" cy="36" r="2" fill="#00ff9d" />
                                    <defs>
                                        <linearGradient id="valueGrad4" x1="12" y1="14" x2="36" y2="36">
                                            <stop stopColor="#00ff9d" />
                                            <stop offset="1" stopColor="#2e8b57" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <h4>Réactivité</h4>
                                <p>À l'écoute de vos besoins et disponible pour vous accompagner</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
